import classNames from 'classnames';

interface FontExampleProps {
    className: string;
}

export const FontExample = ({ className }: FontExampleProps) => (
    <div className={classNames('sds_font-example', className)}>
        Enhancing the specialty pharmacy system for the benefit of pharmacies, payers and patients.
    </div>
);
